const CONNECTION_STEPS = {
    PAIRING: 0,
    REGISTRATION: 1,
    IOT_SYNCHRONIZATION: 2,
};

const connectionSteps = {
    ...CONNECTION_STEPS,
    isAtPairingStep: (step) => step === CONNECTION_STEPS.PAIRING,
    isAtRegistrationStep: (step) => step === CONNECTION_STEPS.REGISTRATION,
    isAtSynchronizationStep: (step) => step === CONNECTION_STEPS.IOT_SYNCHRONIZATION,
};

export default connectionSteps;
